module.exports = __webpack_public_path__ + "static/img/001.6935c54d.png";